export default __webpack_public_path__ + "static/media/1_1.771d54e4.jpg";